'use client';

import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';
import { handleSignOut } from '@/lib/auth-client';

export function SessionExpiredHandler() {
  const { data: session } = useSession();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (session?.error && !hasRedirected.current) {
      hasRedirected.current = true;
      handleSignOut();
    }
  }, [session]);

  return null;
}
